'use strict';

// Which elements contain the custom tag text in this theme (product page + grid).
const TAG_SELECTOR = '.tt-label-custom-tag, .custom-tag';

// The Serbian (source) tag text as it exists in Shopify product.tags.
const SOURCE_TEXT = '50% na drugu NIKE majicu';

// The desired English text for this exact Serbian tag.
const EN_TEXT = '50% Off On Other Nike T-Shirt';

// Weglot source language (defaults to 'sr' if not available).
let tagSourceLang = 'sr';

// Language helpers
// Normalize language codes like 'en', 'en-US', 'sr-Latn' to just base lang.
function tagBaseLang(lang) {
  return lang ? lang.split('-')[0].toLowerCase() : '';
}

// Read the original (Serbian) text stored by Liquid in data-tag-original.
function getOriginalTagText(el) {
return (el.getAttribute('data-tag-original') || '').trim();
}

// Core logic
// Apply the override logic to a single tag element.
// - On source language: restore original Serbian text.
// - On EN: ignore whatever Weglot did and use the original text as the source of truth.
function applyTagOverride(el, lang) {
const base = tagBaseLang(lang);
const original = getOriginalTagText(el);

const sourceBase = tagBaseLang(tagSourceLang);

// Always restore the original value on the source language.
if (base === sourceBase) {
  if (original) el.textContent = original;
  return;
}

// If there is no original, we have nothing reliable to map from.
if (!original) return;

// Only override the one specific Serbian string; everything else is left to Weglot.
if (base === 'en' && original === SOURCE_TEXT) el.textContent = EN_TEXT;
}

// Apply overrides to all tag elements currently in the DOM.
function applyAllTagOverrides(lang) {
const effectiveLang = lang || (typeof Weglot !== 'undefined' ? Weglot.getCurrentLang?.() : undefined);
if (!effectiveLang) return;
document.querySelectorAll(TAG_SELECTOR).forEach(el => applyTagOverride(el, effectiveLang));
}

// Wait until Weglot is available before using its API.
function tagWaitForWeglot(callback) {
if (typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function') {
  callback();
  return;
}

document.addEventListener('weglot:initialized', function onWeglotInit() {
  document.removeEventListener('weglot:initialized', onWeglotInit);
  callback();
});

const poll = setInterval(() => {
  if (typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function') {
    clearInterval(poll);
    callback();
  }
}, 150);
}

// Observe the page for dynamically inserted tag nodes and apply the override.
function startTagObserver() {
  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyAllTagOverrides();
    });
  };

  new MutationObserver(mutations => {
    // Weglot often mutates existing text nodes (characterData) rather than inserting nodes.
    // In both cases, we re-apply once (debounced) for stability.
    for (const mutation of mutations) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        scheduleApply();
        break;
      }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
}

document.addEventListener('DOMContentLoaded', () => {
  tagWaitForWeglot(() => {
    tagSourceLang = Weglot.options?.language_from ?? 'sr';

    // Apply once on initial load, but only after Weglot actually reports
    // the current language (Weglot can be present while getCurrentLang() is still undefined).
    function applyWhenLangReady(maxFrames = 120) {
      let frames = 0;
      const tick = () => {
        const current = Weglot.getCurrentLang();
        if (current) {
          applyAllTagOverrides(current);
          return;
        }
        frames += 1;
        if (frames >= maxFrames) return;
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    // Apply after two animation frames to let Weglot update the DOM first.
    function applyAfterDomSettles(lang) {
      const effectiveLang = lang || Weglot.getCurrentLang();
      if (!effectiveLang) return;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          applyAllTagOverrides(effectiveLang);
        });
      });
    }

    applyWhenLangReady();

    // Re-apply when the user switches language via Weglot.
    Weglot.on('languageChanged', applyAfterDomSettles);

    startTagObserver();
  });
});
